// @flow

import * as React from 'react';
import styled from '@emotion/styled';

type Props = {
  className?: string,
  children?: any,
  disabled?: boolean,
  preventDefault?: boolean,
  stopPropagation?: boolean,
  onClick?: () => void
};

const Wrapper = styled.div(({ disabled, onClick }) => ({
  opacity: disabled ? 0.3 : 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: onClick && !disabled ? 'pointer' : 'default'
}));

const defaultProps = {
  className: undefined,
  children: undefined,
  disabled: false,
  onClick: undefined,
  preventDefault: false,
  stopPropagation: false
};

const Clickable: React.FC<Props> = ({
  children,
  className,
  disabled,
  preventDefault,
  stopPropagation,
  onClick
}: Props) => {
  const handleClick = e => {
    if (preventDefault) {
      e.preventDefault();
    }
    if (stopPropagation) {
      e.stopPropagation();
    }
    if (!disabled) {
      onClick();
    }
  };

  return (
    <Wrapper className={className} onClick={onClick ? handleClick : undefined} disabled={disabled}>
      {children}
    </Wrapper>
  );
};

Clickable.defaultProps = defaultProps;

export default Clickable;
